import React, { Component } from 'react';
import svg from '../img/SVG/envelop.svg';
import instasvg from '../img/SVG/instagram.svg';
import linkedsvg from '../img/SVG/linkedin.svg';
import gitsvg from '../img/SVG/github.svg';
import twittersvg from '../img/SVG/twitter.svg';




class SectionTwo extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="sectionTwo">
                <h3>—Find me On </h3>

                <div className="connection">
                    <a className="connectMe twitter" href="https://twitter.com/A_A_Adedotun">
                        <h5>Twitter</h5>
                        <img src={twittersvg} alt="" className="svg"/>
                    </a>
                    <a className="connectMe instagram" href="https://www.instagram.com/adedotun.js/">
                        <h5>Instagram</h5>
                        <img src={instasvg} className="svg" alt=""/>
                    </a>
                    <a className="connectMe LinkedIn" href="https://www.linkedin.com/in/adedotun-adedigba-60b00b1a5/">
                        <h5>LinkedIn</h5>
                        <img src={linkedsvg} className="svg" alt=""/>

                    </a>
                    <a className="connectMe git" href="https://github.com/dee-d-dev">
                        <h5>Github</h5>
                        <img src={gitsvg} className="svg" alt=""/>
                    </a>
                    <a className="connectMe gmail" href="mailto:adedigbaadedotunemmanuel@gmail.com">
                        <h5>Gmail</h5>
                        <img src={svg} className="svg" alt=""/>

                    </a>


                </div>
            </div>
         );
    }
}
 
export default SectionTwo;